import { computed, readonly, ref } from 'vue'

/**
 * Стек «откуда пришли» при переходах по цитатам.
 * Кнопка «вниз» снимает вершину и возвращает к сохранённому сообщению.
 *
 * Цепочка продолжается только если новая цитата в том же сообщении,
 * на которое перешли предыдущим кликом; иначе стек сбрасывается.
 */
export const useMessageNavigationStack = () => {
  const stack = ref<number[]>([])
  const lastTargetEventId = ref<number | null>(null)

  const hasEntries = computed(() => stack.value.length > 0)

  const clear = () => {
    stack.value = []
    lastTargetEventId.value = null
  }

  const pushFromQuote = (sourceEventId: number, targetEventId: number) => {
    if (!sourceEventId || !targetEventId) {
      return
    }

    if (
      lastTargetEventId.value !== null
      && sourceEventId !== lastTargetEventId.value
    ) {
      stack.value = []
    }

    if (stack.value.at(-1) !== sourceEventId) {
      stack.value.push(sourceEventId)
    }

    lastTargetEventId.value = targetEventId
  }

  const pop = (): number | undefined => {
    const backToEventId = stack.value.pop()
    lastTargetEventId.value = backToEventId ?? null
    return backToEventId
  }

  return {
    stack: readonly(stack),
    lastTargetEventId: readonly(lastTargetEventId),
    hasEntries,
    pushFromQuote,
    pop,
    clear,
  }
}
